<template>
    <div class="music-view-component"
        @click="clickMusic()"
        :style="{
            backgroundImage: `url(${image})`,
            backgroundPosition: 'center center', 
            backgroundRepeat: 'repeat-x'
        }"
    >
        <audio 
            v-if="audio" 
            :src="localAudio" 
            :id="id"
            preload="auto"
        ></audio>
    </div>
</template>

<script>
    export default {
        props: {
            music: {
                default: false
            },
            audio: {
                default: false
            },
            id: {
                default: false
            }
        },
        computed: {
            image() {
                return require('~/assets/' + 'timbre.png')
            },
            localAudio() {
                try {
                    if(this.audio) {
                        if(this.audio.indexOf('http') === -1) {
                            return require('~/assets/music/' + `${this.audio}`)
                        } else {
                            return this.audio
                        }
                    }
                } catch(e) {
                    console.error(e)
                    return false
                }
            }
        },
        methods: {
            async clickMusic() {
                this.$emit('clickMusic', {
                    music: this.music
                })
            }
        }
    }
</script>

<style lang="less">
    .music-view-component {
        width: 100%;
        height: 100%;
        background-color: #322B53;
        position: absolute;
        top: 0px;
        right: 0px;
    }

    .music-view-component audio{
        width: 0px;
        height: 0px;
        opacity: 0;
        z-index: 0;
    }
</style>